import { config, createTheme } from '@rango-dev/ui';
/*
 * `@rango-dev/ui` (Stitches) token scales whose CSS custom-property names are
 * shadowed by Radix Themes' global `.radix-themes` scope. Today only `space`
 * actually collides (Radix's `--space-N` overrides the widget's), but re-emitting
 * the widget's full NON-COLOR token set future-proofs against new scales/tokens
 * or renames: they are spread from `config.theme`, so they stay in sync as the
 * widget's design tokens evolve.
 *
 * `colors` are deliberately excluded:
 *   - Stitches color vars (`--colors-*`) don't collide with Radix's
 *     (`--accent-*` / `--gray-*` / `--color-*`), so Radix never shadows them.
 *   - The active light/dark (and app-customized) color theme is applied on
 *     <body> by the app's Bootstrap and flows through untouched.
 *   - Dark mode overrides ONLY `colors`, so re-emitting them here would pin the
 *     base/light palette on this subtree and break dark mode.
 */
const { colors: _colors, ...widgetNonColorScales } = config.theme;
/**
 * Class that re-asserts the widget's non-color design tokens locally. Append it
 * to an existing element that renders non-migrated `@rango-dev/ui` content
 * inside a Radix Themes subtree, when you don't want an extra wrapper node.
 */
export const widgetThemeScopeClassName = createTheme(widgetNonColorScales).toString();
